import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EyeCloseIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EyeCloseIcon = ({ className, ...props }: EyeCloseIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.3166 8.22012C19.4866 7.84272 19.9302 7.67343 20.3078 7.84317C20.6854 8.0131 20.8535 8.4577 20.6837 8.83536C19.9205 10.5314 18.8181 11.8532 17.5275 12.8022L19.2736 15.1977C19.5169 15.5323 19.4429 16.0017 19.1086 16.2455C18.7739 16.4891 18.3046 16.4148 18.0607 16.0805L16.2462 13.5912C15.1445 14.1531 13.9555 14.4831 12.7502 14.5795V16.9721C12.7502 17.3862 12.4143 17.722 12.0002 17.7221C11.5859 17.7221 11.2502 17.3863 11.2502 16.9721V14.5795C10.0445 14.4831 8.85502 14.1534 7.75308 13.5912L5.93961 16.0805C5.69569 16.4149 5.22641 16.4891 4.89175 16.2455C4.55725 16.0017 4.48326 15.5324 4.72672 15.1977L6.47183 12.8022C5.18137 11.8533 4.07974 10.5312 3.31656 8.83536C3.14675 8.45768 3.31488 8.01311 3.69254 7.84317C4.07008 7.67359 4.51376 7.84272 4.68375 8.22012C7.61849 14.7412 16.3818 14.7412 19.3166 8.22012Z"
      fill="currentColor"
    />
  </svg>
);

export default EyeCloseIcon;
